import { Util } from './core/cafm.util.jsx';
import { HeaderContainer, SubHeaderContainer, DashboardLayout } from './widgets/cafm.app.jsx';
import { CafmButtonGroup, GridColumnChooser, HoursTicker } from './widgets/cafm.widgets.jsx';
import { Scanner } from './widgets/cafm.scanner.jsx';
import "./core/cafm.core.jsx";
import "./widgets/cafm.widgets.jsx";
import "./modules/cafm.modules.jsx";

cafm.CAFMReactDOM = {
    Components: {
        'HeaderContainer': HeaderContainer,
        'DashboardLayout': DashboardLayout,
        'GridColumnChooser': GridColumnChooser,
        'SubHeaderContainer': SubHeaderContainer,
        'CafmButtonGroup': CafmButtonGroup,
        'HoursTicker': HoursTicker
    },
    Disposable: {
        nodes: [],
        unmountAll(element) {

            cafm.handlers.exe("cafm.unmountReactDisposable", ReactDOM, element);
        },
        render(element, container, callback) {

            return cafm.handlers.exe("cafm.renderReactDisposable", ReactDOM, element, container, callback);
        }
    },
    render: function (reactElementName, reactElementProps, container, callback, disposable, refreshIfAlreadyCreated) {

        let instance;
        if (refreshIfAlreadyCreated) {

            instance = window[reactElementName];

            if (instance) {

                instance.refresh(reactElementProps);

                Util.callFunction(callback, {
                    container: container,
                    props: reactElementProps
                });

                return instance;
            }
        }

        instance = (disposable === true ? this.Disposable : ReactDOM).render(React.createElement(isStr(reactElementName) ? this.Components[reactElementName] : reactElementName, reactElementProps), container, callback ? function (args) {
            Util.callFunction(callback, {
                container: container,
                props: reactElementProps
            });
        } : null);

        if (refreshIfAlreadyCreated) {

            window[reactElementName] = instance;
        }

        return instance;
    },
    unmountComponentAtNode: function (node) {

        ReactDOM.unmountComponentAtNode(node);
    }
};
cafm.Scanner = Scanner;
export default cafm;